import {
    CANCEL_INTERVIEW_VENDOR_REQUEST,
    CANCEL_INTERVIEW_VENDOR_SUCCESS,
    CANCEL_INTERVIEW_VENDOR_FAIL
  } from "../constants/AuthConstant";
import axios from "axios";
import { toast } from "react-toastify";


export const CancelInterviewAction = (data) => {
  return function (dispatch) {
    dispatch({
      type: CANCEL_INTERVIEW_VENDOR_REQUEST,
      payload: true,
    });

    const OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/interview/cancel_interview?interviewId=${data?.interviewId}&cancellationReason=${data?.interviewCancellationReason}`,
      method: "PUT",
      data: data,
      headers: {
        "content-type": "application/json",
      },
    };

    return new Promise((resolve, reject) => {
      axios(OPTION)
        .then((res) => {
          console.log("API Response:", res?.data); // Debugging log
          dispatch(CancelInterviewPre(res?.data));
          resolve(res?.data); // Ensure response structure is correct
        })
        .catch((error) => {
          console.error("API Error:", error); // Debugging log
          dispatch({
            type: CANCEL_INTERVIEW_VENDOR_FAIL,
            payload: false,
            error: error,
            createJob: error?.success,
            msg: error?.response?.data?.message || "Failed to cancel interview",
          });
          toast.error(error?.response?.data?.message || "Failed to cancel interview");
          reject(error);
        });
    });
  };
};

export const CancelInterviewPre = (data) => {
  console.log("CancelInterviewPre Data:", data); // Debugging log
  toast.success("Interview cancelled successfully");
  return {
    type: CANCEL_INTERVIEW_VENDOR_SUCCESS,
    createJob: data?.status?.message,
    result: data,
    payload: false,
    msg: data?.status?.message,
  };
};
